class CollectionFilterDropdown extends HHBaseElement {
  loading = false

  constructor() {
    super()
    this.$toggle = this.querySelector('[data-toggle]')
    this._handleToggle = this._handleToggle.bind(this)
    this.close = this.close.bind(this)
    this._handleDocumentClick = this._handleDocumentClick.bind(this)
  }

  connectedCallback() {
    this._attachListeners()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  static get observedAttributes() {
    return ['open']
  }

  get isAccordionMode() {
    return this.hasAttribute('accordion')
  }

  get isOpen() {
    return this.hasAttribute('open')
  }

  _attachListeners() {
    document.addEventListener('change::filters', this._handleDocumentClick)
    this.$toggle.addEventListener('click', this._handleToggle)
    if (!this.isAccordionMode) {
      // this.addEventListener('change', this.close)
      document.addEventListener('click', this._handleDocumentClick)
    }
  }

  _removeListeners() {
    this.removeEventListener('change', this.close)
    this.$toggle.removeEventListener('click', this._handleToggle)
    document.removeEventListener('click', this._handleDocumentClick)
  }

  close() {
    this.removeAttribute('open')
    this.$toggle.setAttribute('aria-expanded', false)
  }

  open() {
    this.setAttribute('open', '')
    this.$toggle.setAttribute('aria-expanded', true)
  }

  _handleCloseOthers() {
    const accordions = this.parentNode.querySelectorAll(
      'collection-filter-dropdown'
    )

    for (const accordion of accordions) {
      if (accordion != this) {
        accordion.close()
      }
    }
  }

  _handleToggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  _handleDocumentClick(event) {
    if (this.isOpen && !this.contains(event.target)) {
      this.close()
    }
  }
}

window.customElements.define(
  'collection-filter-dropdown',
  CollectionFilterDropdown
)
